import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 20px;
    color: #abb2bf;
  }

  .toolbar {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    align-items: center;
  }

  .btn {
    padding: 5px 12px;
    background: #2c313a;
    color: #abb2bf;
    border: 1px solid #3e4451;
    cursor: pointer;
    font-size: 18px;
    border-radius: 3px;
    font-family: inherit;
  }

  .btn-danger {
    color: #e06c75;
    border-color: #e06c75;
  }

  .btn-disabled {
    color: #5c6370;
    border-color: #3e4451;
    cursor: default;
  }

  .section-heading {
    margin: 16px 0 6px;
    font-size: 15px;
    color: #528bff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-weight: 700;
    font-family: inherit;
  }

  .flag-row {
    display: grid;
    grid-template-columns: 1fr 60px 84px;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-bottom: 1px solid #2c313a;
    font-size: 20px;
    font-family: inherit;
  }

  .flag-row--overridden {
    background: #2c313a;
  }

  .label-group {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .flag-key {
    font-size: 20px;
    color: #abb2bf;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
  }

  .override-badge {
    font-size: 13px;
    color: #5c6370;
    letter-spacing: 0.3px;
    white-space: nowrap;
  }

  .status {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    font-size: 17px;
    font-weight: 700;
  }

  .status-dot {
    width: 14px;
    text-align: center;
    flex-shrink: 0;
  }

  .status-label {
    width: 28px;
  }

  .toggle-btn {
    padding: 3px 10px;
    background: #2c313a;
    border-radius: 3px;
    cursor: pointer;
    font-size: 15px;
    font-family: inherit;
    font-weight: 600;
    width: 84px;
    text-align: center;
  }

  .toggle-btn--override {
    color: #528bff;
    border: 1px solid #528bff;
  }

  .toggle-btn--clear {
    color: #e06c75;
    border: 1px solid #e06c75;
  }

  .hint {
    margin-top: 12px;
    padding: 8px 10px;
    background: #2c313a;
    border-left: 3px solid #528bff;
    color: #5c6370;
    font-size: 16px;
    font-family: inherit;
  }

  .empty {
    padding: 16px;
    color: #5c6370;
    font-size: 20px;
    font-family: inherit;
  }

  .empty a {
    color: #528bff;
    text-decoration: underline;
  }

  .empty a:hover {
    color: #7aa8ff;
  }
`;
